export default __webpack_public_path__ + "static/media/3d-object-min-v2.c0a7b16c.png";